<template lang="pug">
	div.default-modal
		loading(:active.sync="busy", :is-full-page="true")
		.modal-header
			.modal-title Select OS Versions
			a.close(href="javascript:void(0);", @click="$emit('close')")
				i.la.la-times
		.modal-body
			.modal-body-inner
				form.form.form-inline.ov-filters(@submit.prevent="loadData()")
					.form-row-main
						div
							.form-group
								label Search
								input.form-control(type="text", placeholder="Keyword...", v-model="filters.keyword")
							.form-group
								label OS
								select.form-control(v-model="filters.platform")
									option(v-for="o in platformOptions", :value="o.v") {{ o.t }}
							.form-group
								label From Version
								input.form-control(type="text", v-model="filters.minVersion", placeholder="0.0.0")
							.form-group
								label To Version
								input.form-control(type="text", v-model="filters.maxVersion", placeholder="0.0.0")
							.form-group.no-label
								button.btn.btn-primary(type="submit") Go

					.form-row-end(v-if="multiple")
						.form-group
							label &nbsp;
							button.btn.btn-primary(type="button", @click="submitSelection()") Submit ({{bucket.length}})

				p.clearfix &nbsp;
				ov-table-scroll
					.tabs.table-tabs
						ul.nav.nav-tabs
							li.nav-item
								a.nav-link(:class="{active:selectedTab==='search'}", @click="selectedTab='search'") Search ({{ paginate.total }})
							li.nav-item
								selected-items-tab(:count="bucket.length", :active="selectedTab==='bucket'", @click="selectedTab='bucket'")
					table.table.table-bordered.table-offer-list
						thead
							tr
								th ID
								th Version
								th Platform
								th(v-if="multiple")
									span(v-if="selectedTab==='search'")
										a(href="javascript:void(0);", @click="selectAll()") All
										=' | '
									span
										a(href="javascript:void(0);", @click="clearBucket()") Clear
						tbody
							tr(v-if="records.length === 0")
								td(colspan="11") No matching records were found
							tr(v-for="r in (selectedTab==='bucket'?bucket:records)", v-bind:key="r.id", :class="{'row-selected': bucketHash[r.id]}")
								td {{ r.id }}
								td {{ r.name }}
								td {{ r.platform }}
								td.col-select(:class="{'bucket-row':bucketHash[r.id]}", v-if="couldBeSelected(r)")
									a(href="javascript:void(0)", v-if="multiple", @click="toggleBucket(r)")
										i.la(:class="{'la-check-square':bucketHash[r.id], 'la-stop':!bucketHash[r.id]}")
									a(href="javascript:void(0)", v-else, @click="submitOneOffer(r)")
										i.la.la-plus
								td(v-else)
					paginate(v-if="selectedTab==='search'", :paginator="paginate", @update-page-size="loadData")
</template>
<style lang="scss"></style>
<script>
import Vue from 'vue';

export default {
	name: 'SelectOsVersion',
	props: {
		selectedVersions: {
			type: [Array],
		},
		complex: {
			type: [Boolean],
			default() {
				return false;
			},
		},
		multiple: {
			type: [Boolean],
		},
		disabledFilters: {
			type: [Object],
			default() {
				return {
					hasCreatives: null,
				};
			},
		},
	},
	data() {
		return {
			records: [],
			busy: false,
			paginate: {
				numPages: 0,
				total: 0,
				page: 1,
				limit: 20,
				onPageChange: () => {
					this.loadData();
				},
			},
			showAdvancedFilters: false,
			selectedTab: 'search',
			bucket: [],
			bucketHash: {},
			filters: {
				keyword: '',
				platform: 'all',
				minVersion: '',
				maxVersion: '',
			},
			platformOptions: [
				{ v: 'all', t: 'All' },
				{ v: 'android', t: 'Android' },
				{ v: 'ios', t: 'iOS' },
				{ v: 'mobile_web', t: 'MobileWeb' },
				{ v: 'desktop', t: 'Desktop' },
			],
			sortBy: {
				field: 'name',
				direction: 'asc',
				sort: null,
			},
		};
	},
	async mounted() {
		if (this.selectedVersions && this.selectedVersions.length) {
			let versionIds = this.selectedVersions.map((r) => r.id);
			let resp = await this.$ovReq.get('os-version/getList', { params: { id: versionIds.join(',') } });
			resp.records.forEach((r) => {
				const option = this.platformOptions.find(o => o.v === r.platform);
				r.platform = option ? option.t : 'Unknown';
				this.toggleBucket(r);
			});
		}
		// this.loadData();
	},
	methods: {
		submitSelection() {
			while (this.selectedVersions.length) {
				this.selectedVersions.splice(0, 1);
			}
			this.bucket.forEach((r) => {
				this.selectedVersions.push({
					id: r.id,
					name: r.name,
					advertiser_id: r.advertiser_id,
					advertiser_name: r.advertiser_name,
				});
			});
			this.$emit('close', this.bucket);
		},
		submitOneOffer(r) {
			this.bucket = [r];
			this.submitSelection();
		},
		clearBucket() {
			this.bucket = [];
			this.bucketHash = {};
		},
		selectAll() {
			this.records.forEach((r) => {
				if (!this.bucketHash[r.id]) {
					Vue.set(this.bucketHash, r.id, true);
					this.bucket.push(r);
				}
			});
		},
		toggleBucket(r) {
			if (this.bucketHash[r.id]) {
				Vue.set(this.bucketHash, r.id, false);
				for (let i = 0; i < this.bucket.length; i++) {
					if (this.bucket[i].id === r.id) {
						this.bucket.splice(i, 1);
						return;
					}
				}
			} else {
				Vue.set(this.bucketHash, r.id, true);
				this.bucket.push(r);
			}
		},
		async loadData() {
			this.busy = true;
			let params = {
				page: this.paginate.page,
				page_size: this.paginate.limit,
				keyword: this.filters.keyword,
				minVersion: this.filters.minVersion,
				maxVersion: this.filters.maxVersion,
				platform: this.filters.platform,
				sort_col: this.sortBy.field,
				sort_dir: this.sortBy.direction,
			};
			try {
				let resp = await this.$ovReq.get('os-version/getList', { params });
				this.records = resp.records;
				this.records.forEach((r) => {
					const option = this.platformOptions.find(o => o.v === r.platform);
					r.platform = option ? option.t : 'Unknown';
				});
				this.paginate.total = resp.total;
				this.paginate.numPages = Math.max(Math.ceil(this.paginate.total / this.paginate.limit), 1);
			} catch (e) {
				console.error(e);
			}
			this.busy = false;
		},
		couldBeSelected(r) {
			if (this.disabledFilters.hasCreatives) {
				return r.has_creatives;
			}
			return true;
		},
	},
};
</script>
